import Vue from 'vue'
import App from '@/app/App'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { abilitiesPlugin } from '@casl/vue'

import Popper from 'popper.js'
import { ServerTable, ClientTable } from 'vue-tables-2'
import VueProgressBar from 'vue-progressbar'
import Notifications from 'vue-notification'
import TasksTodoNotify from '@/app/shared/components/notify/TasksTodoNotify.js'
import VueSweetalert2 from 'vue-sweetalert2'
import InfiniteLoading from 'vue-infinite-loading'
import Multiselect from 'vue-multiselect'
import MaskedInput from 'vue-text-mask'
import VueMoment from 'vue-moment'
import moment from 'moment-duration-format'
import vueDebounce from 'vue-debounce'
import VueExcelEditor from 'vue-excel-editor'
import iconStyled from '@/app/company-document/iconsStyeld.vue'

import '@/vendor/libs/vue-multiselect/vue-multiselect.scss'
import '@/vendor/libs/vue-notification/vue-notification.scss'
import '@/app/shared/filters/label-mask'
import '@/vendor/libs/vue-data-tables/vue-data-tables.scss'

import store from '@/app/state'
import globals from '@/globals'
import router from '@/router'

Vue.use(VueProgressBar, {
  color: '#00b3eb',
  height: '2px',
  speed: '0.4s'
})

Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(abilitiesPlugin, store.getters['auth/ability'])
Vue.use(ServerTable, {}, true, 'bootstrap4', { sortControl: iconStyled })
Vue.use(ClientTable, {}, false, 'bootstrap4', { sortControl: iconStyled })
Vue.use(Notifications)
Vue.use(VueSweetalert2, {
  confirmButtonClass: 'btn btn-primary',
  cancelButtonClass: 'btn btn-danger'
})
Vue.use(InfiniteLoading, { /* options */ })
Vue.use(TasksTodoNotify)
Vue.use(VueMoment, moment)
Vue.use(VueExcelEditor)

Vue.use(vueDebounce, {
  listenTo: 'keyup',
  defaultTime: '100ms'
})

Vue.component('multiselect', Multiselect)
Vue.component('masked-input', MaskedInput)

// Global RTL flag
Vue.mixin({
  data: globals
})

export default new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
